<template>
  <div class="elite-tabs-wrapper-content">
    <div class="custom-header">
      <h3>
        {{ `${customer.customer_name}` }} -
        {{ $t("COMMON.LOGS") }}
      </h3>
    </div>
    <log-list-table :filterSubject="customer" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "customer-view-logs",

  components: { LogListTable },

  props: ["customer"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
